import React from 'react';
import PageLayout from '@/components/PageLayout';
import { useI18n } from '@/i18n/LanguageContext';

const CreditsPage = () => {
  const { t } = useI18n();

  return (
    <PageLayout title={t('credits.title')}>
      <div className="max-w-3xl mx-auto space-y-6">
        <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
          <h2 className="text-xl font-semibold mb-4">{t('credits.icons')}</h2>
          <p className="text-gray-600 dark:text-gray-300">
            Brand-style icons made by [Author Name] on Iconfinder, licensed under CC BY 3.0. Icons modified for color.
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default CreditsPage;
